import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';

import { IPlanFormValues } from '../interfaces/PlanForm';

export type IPlanUpdateRequest = Partial<IKnmPlan> & {
  ervkProsecutorOrgUuid: string;
  ervkProsecutorOrgVersionUuid: string;
  prosecutorOrgName: string;
};

/**
 * Собирает тело запроса на обновление плана с данными подписанта из формы.
 * Используется во всех сценариях подписания плана (в браузере, тестовое,
 * загрузка открепленной подписи)
 */
export const buildPlanUpdateRequest = (plan: IKnmPlan, form: IPlanFormValues): IPlanUpdateRequest => ({
  ervkProsecutorOrgUuid: plan.prosecutorOrganizationErvkUuid!,
  ervkProsecutorOrgVersionUuid: plan.prosecutorOrganizationErvkVersionUuid!,
  prosecutorOrgName: plan.prosecName,
  knoId: plan.knoId,
  knoName: plan.knoName,
  type: plan.type,
  creationType: plan.creationType,
  startDate: plan.startDate,
  endDate: plan.endDate,
  year: plan.year,
  knmPlanData: plan.knmPlanData && {
    ...plan.knmPlanData,
    signerFullName: form.signerFullName!,
    signerPosition: form.signerPosition!,
  },
});
